import store from './store';
import { checkAuthorization } from '../auth/Authorization';

export default () =>
  new Promise(() => {
    store.dispatch(checkAuthorization());
  });
